import React from 'react';
import { Button } from '@mui/material';
import useRUMView from 'common-datadog/useRUMView';
import Screen from '../Screen';
import Disclaimers from '../Disclaimers';

const DailyLimitReached = () => {
  useRUMView('daily_limit_reached');

  return (
    <Screen
      header="Unfortunately, your application cannot proceed at this time."
      subheader="You have reached the max amount of attempts for our loan application. Please try again in 24 hours."
    >
      <Disclaimers textAlign="center">
        Please note that your credit score was not affected.
      </Disclaimers>
      <Button href={`/${process.env.PREFIX}/auth/logout`}>
        Sign Out
      </Button>
    </Screen>
  );
};

export default DailyLimitReached;
